import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAetherContext } from '#pplx/frontend/aether/components/AetherProvider/useAetherContext.js';
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { SourcesMenuManageConnectors } from '#pplx/frontend/apps/ask/ask-input/ask-input-sources-menu/components/SourcesMenuManageConnectors.js';
import { useIsSubscribed } from '#pplx/frontend/auth/useIsSubscribed.js';
import { memo } from 'react';
export const SourcesMenuFooter = memo(function SourcesMenuFooter() {
    const { hasAccessToProFeatures } = useIsSubscribed();
    const { isMobileStyle } = useAetherContext();
    if (!hasAccessToProFeatures) {
        return null;
    }
    return (_jsxs(DropdownMenu.Footer, { children: [!isMobileStyle && _jsx(DropdownMenu.Separator, {}), _jsx(SourcesMenuManageConnectors, {})] }));
});
//# sourceMappingURL=SourcesMenuFooter.js.map